/* eslint-disable @typescript-eslint/no-use-before-define */
const kmeans = (inputs: number[], k: number): number[][] => {
  let clusters: number[][] = []
  const sortedInputs = [...inputs].sort((a, b) => a - b)
  let centroids = generateInitialCentroids(sortedInputs, k)

  let converged = false
  while (!converged) {
    const newClusters = clustering(sortedInputs, centroids)
    const newCentroids = generateCentroidsWith(newClusters, k)

    converged = centroids.every((centroid, i) => centroid === newCentroids[i])

    clusters = newClusters
    centroids = newCentroids
  }

  return clusters.sort((clusterA, clusterB) => clusterA[0] - clusterB[0])
}

export default kmeans

const generateInitialCentroids = (inputs: number[], k: number) => {
  const initialIndex = Math.round(inputs.length / (k + 1))
  return [...Array(k)].map((_, i) => {
    const index = initialIndex * (i + 1)
    return inputs[index]
  })
}

const clustering = (inputs: number[], centroids: number[]) => {
  const clusters: number[][] = []
  inputs.forEach((input) => {
    const closestCentroidIndex = findClosestCentroidIndex(input, centroids)

    if (!clusters[closestCentroidIndex]) clusters[closestCentroidIndex] = []
    clusters[closestCentroidIndex].push(input)
  })
  return clusters
}

const findClosestCentroidIndex = (target: number, centroids: number[]) => {
  const distances = centroids.map((centroid) => Math.abs(centroid - target))
  const minDistance = Math.min(...distances.filter((d) => !Number.isNaN(d)))
  return distances.findIndex((d) => d === minDistance)
}

const generateCentroidsWith = (clusters: number[][], k: number) =>
  [...Array(k)].map((_, i) => {
    const cluster = clusters[i]
    if (!cluster) return 0
    const total = cluster.reduce((a, b) => a + b, 0)
    const average = total / cluster.length
    return average
  })
